import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Button, Stack } from "@mui/material";
import {
  RegistrationCard,
  FruitifyStack,
  FruitifyContainer,
} from "../../../shared-components/Containers";
import FruitifyLogo from "../../../shared-components/FruitifyLogo";
import { useTrackingAnalytics } from "../../../hooks/useTrackingAnalytics";

const RegistrationSuccess = () => {
  const navigate = useNavigate();
  const { recordMarketingEvent } = useTrackingAnalytics();

  useEffect(() => {
    recordMarketingEvent("registered", {}, true);
  }, []);

  return (
    <FruitifyContainer>
      <FruitifyStack
        direction="column"
        justifyContent="space-between"
        data-testid={"fruitify-registration-success-page"}
        sx={{ height: "100%" }}
      >
        <RegistrationCard variant="outlined">
          <Stack direction={"row"} justifyContent={"center"}>
            <FruitifyLogo />
          </Stack>
          <Typography variant="h4" gutterBottom>
            Registration Successful!
          </Typography>

          <Stack direction={"column"} spacing={2} align="justify">
            <Typography variant="body1" align="justify">
              A confirmation email has been sent to your email. Please activate
              your account before continue to login.
            </Typography>
          </Stack>

          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={() => navigate("/login")}
            sx={{ mt: 2 }}
          >
            Continue to Login
          </Button>
        </RegistrationCard>
      </FruitifyStack>
    </FruitifyContainer>
  );
};

export default RegistrationSuccess;
